export const duplicateTypes = Object.freeze({
    selfRegPersonalDetails: 1,
    autoPersonalDetails: 2,
    autoNameAndCompany: 3,
    newStudentPersonalDetails: 4,
    newStudentNameAndCompany: 5,
})